var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { atom, useRecoilState, useRecoilValue } from 'recoil';
import store from 'store';
import { useEffect } from 'react';
import { autoSyncRecoil } from './useGlobalStates';
import isObject from 'lodash/isObject';
var recoils = {};
export function createGlobalState(input) {
    var _a = input.id, id = _a === void 0 ? Math.random().toString() : _a, initialValue = input.initialValue, _b = input.autoSync, autoSync = _b === void 0 ? false : _b;
    var getDefaultValue = function () {
        if (autoSync) {
            var storeValue = store.get(id);
            if (storeValue !== undefined) {
                if (isObject(initialValue)) {
                    return Object.assign(initialValue, storeValue);
                }
                return storeValue;
            }
            return initialValue;
        }
        return initialValue;
    };
    var existing = recoils[id];
    var recoil = existing ||
        atom({
            key: id,
            default: getDefaultValue(),
        });
    if (!existing && autoSync) {
        autoSyncRecoil({ id: id, recoil: recoil });
    }
    return {
        useState: function () {
            return useRecoilState(recoil);
        },
        useAutoSync: function () {
            var value = useRecoilValue(recoil);
            useEffect(function () {
                store.set(id, value);
            }, [id, value]);
        },
        useReset: function () {
            var _a = useRecoilState(recoil), setState = _a[1];
            return function () {
                if (initialValue) {
                    setState(__assign({}, initialValue));
                }
            };
        },
    };
}
